module.exports = __webpack_public_path__ + "media/images/responsive/logo/service/logo_marriage-736f5d3716057964cecfd22569069500.svg";